<div class="maintenance-page">
  <img src="assets/images/maintenance.png" alt="Robot Image" width="150">
  <h1>Site Under Maintenance</h1>
  <p>We apologize for the inconvenience, but our site is currently undergoing maintenance.</p>
  <p>Please check back later.</p>
</div>
